module.exports = __webpack_public_path__ + "static/media/jw_black.65e4784d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/bottles/backgrounds/Love/jw_black.jpg
// module id = 722
// module chunks = 0